export const GetCategorizeVendors = `
    query MyQuery($hotelId: String!) {
      GetCategorizeVendors(input: {hotelId: $hotelId}) {
        curtains {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedAt
        }
        ddks {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedAt
        }
        thermostats {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedAt
        }
        scenes {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedAt
        }
        lights {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedBy
        }
        doorLock {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedBy
        }
        doorCamera {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedBy
        }
        DND {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedBy
        }
        MMR {
          id
          name
          type
          enabledAttributes
          createdAt
          updatedBy
        }
      }
    }
  `;

export const getUserById =
  /* GraphQL */
  `
    query MyQuery($input: String!) {
      getUserById(id: $input) {
        id
        firstName
        email
        phoneNumber
        lastName
        imageUrl
        mfaEnforced
      }
    }
  `;

export const getUserDetailsById =
  /* GraphQL */
  `
    query MyQuery($input: String!) {
      getUserById(id: $input) {
        brand
        brandId
        createdAt
        createdBy
        department
        departmentId
        email
        employeeId
        firstName
        groupId
        hotel
        imageUrl
        id
        hotelId
        group
        isPhoneVerified
        lastName
        phoneNumber
        role
        roleId
        roles
        status
        restaurantId
        mfaEnforced
      }
    }
  `;

export const getGroupList =
  /* GraphQL */
  `
    query MyQuery {
      getGroups {
        id
        code
        name
        description
        createdBy
      }
    }
  `;

export const getBrandList =
  /* GraphQL */
  `
    query MyQuery {
      getBrands {
        id
        groupId
        code
        name
        description
        createdBy
        images
        mediaContent {
          key
          value
        }
      }
    }
  `;

export const getHotelList =
  /* GraphQL */
  `
    query MyQuery {
      getHotels {
        id
        groupId
        brandId
        code
        name
        description
        checkInTime
        checkOutTime
        currency
        createdBy
        location {
          addressLine1
          addressLine2
          country
          state
          postalCode
          city
          latitude
          longitude
          timezone
        }
        information {
          field
          index
          value
          type
          displayTitle
        }
        images
        mediaContent {
          key
          value
        }
      }
    }
  `;

export const getBrandListByGroupId =
  /* GraphQL */
  `
    query MyQuery($input: String!) {
      getBrandsByGroupId(groupId: $input) {
        id
        code
        name
        description
        images
        mediaContent {
          key
          value
        }
      }
    }
  `;

export const getGroupById =
  /* GraphQL */
  `
    query MyQuery($input: String!, $lang: String) {
      getGroupById(id: $input, lang: $lang) {
        id
        code
        name
        description
      }
    }
  `;

export const getBrandById =
  /* GraphQL */
  `
    query MyQuery($id: String!, $lang: String) {
      getBrandById(id: $id, lang: $lang) {
        id
        code
        name
        description
        groupId
        images
        mediaContent {
          key
          value
        }
      }
    }
  `;

// start of accommadations queries
// start of category quesries

export const getCategoryListWithCounts =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!) {
      getCategoryListWithCounts(input: { hotelId: $hotelId }) {
        code
        hotelId
        roomCount
        id
        name
        roomTypeCount
      }
    }
  `;

export const getCategoryById =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $categoryId: String!) {
      getCategoryListWithCounts(input: { hotelId: $hotelId, categoryId: $categoryId }) {
        code
        hotelId
        roomCount
        roomNumbers
        id
        name
        roomTypeCount
        roomTypes
        createdBy
      }
    }
  `;

export const getRoomTypeListWithCounts =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!) {
      getRoomTypeListWithCounts(input: { hotelId: $hotelId }) {
        categoryId
        code
        description
        displayDescription
        displayName
        features
        hotelId
        id
        images
        mediaContent {
          key
          value
        }
        maxAdults
        maxBeddingPerRoomType
        maxChildren
        maxInfants
        maxOccupants
        name
        ratePerNight
        roomCount
      }
    }
  `;

export const getFloorDetailsByHotelIdAndFloorId =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $id: String!) {
      getFloorDetails(input: { hotelId: $hotelId, id: $id }) {
        number
        name
        id
        hotelId
        categoryIds
        roomRangeList {
          index
          rangeFrom
          rangeTo
        }
        roomTypeIds
        createdBy
      }
    }
  `;

export const getRoomTypeDetailsByHotelIdAndFloorId =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $id: String!) {
      getRoomTypeByHotelIdAndId(input: { hotelId: $hotelId, id: $id }) {
        id
        categoryId
        code
        createdBy
        description
        displayDescription
        displayName
        features
        images
        mediaContent {
          key
          value
        }
        maxAdults
        maxBeddingPerRoomType
        maxChildren
        maxInfants
        maxOccupants
        name
        ratePerNight
      }
    }
  `;

export const getFloorListByHotelId =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!) {
      getFloorListByHotelId(input: { hotelId: $hotelId }) {
        createdBy
        hotelId
        id
        name
        number
        roomRangeList {
          rangeFrom
          rangeTo
        }
      }
    }
  `;

export const getRoomListByHotelId =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!) {
      getRoomListByHotelId(input: { hotelId: $hotelId, limit: 1000, nextToken: "" }) {
        data {
          roomTypeId
          number
          description
          area
          areaSizeUnit
          roomView
          isSmokingAllowed
          maxOccupancy
          houseKeepingDaySection
          houseKeepingEveningSection
          categoryId
          createdBy
          hotelId
          id
          isActive
          isAdultRequired
        }
      }
    }
  `;

export const getRoomById =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $id: String!) {
      getRoomById(input: { hotelId: $hotelId, id: $id }) {
        roomTypeId
        number
        description
        area
        areaSizeUnit
        roomView
        isSmokingAllowed
        maxOccupancy
        houseKeepingDaySection
        houseKeepingEveningSection
        categoryId
        createdBy
        hotelId
        id
        isActive
        isAdultRequired
      }
    }
  `;

export const getPropertyDetails =
  /* GraphQL */
  `
    query MyQuery($lang: String) {
      getPropertyDetails(input: { lang: $lang }) {
        brands {
          code
          id
          name
          description
          createdBy
          groupId
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to16
            ratio9to21
          }
          mediaContent {
            key
            value
          }
        }
        groups {
          code
          createdBy
          description
          id
          name
          customSenderEmail
          firebaseToken
          whiteLabellingConfigurations {
            appConfigs
            region
          }
        }
        hotels {
          id
          brandId
          code
          createdBy
          currency
          groupId
          description
          checkInTime
          checkOutTime
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to16
            ratio9to21
          }
          mediaContent {
            key
            value
          }
          features
          covid19Regulations {
            type
            url
            name
          }
          termsAndConditions {
            type
            url
            name
          }
          cancellationPolicy {
            type
            url
            name
          }
          dataProtection {
            type
            url
            name
          }
          privacyLaws {
            type
            url
            name
          }
          information {
            field
            index
            value
            type
            displayTitle
          }
          location {
            addressLine1
            addressLine2
            city
            country
            latitude
            longitude
            postalCode
            state
            timezone
            area
          }
          name
          checkInTime
          checkOutTime
          travelType
          starRating
          interests
          phoneNumber
          isUIBuilderEnabled
          isDevicesEnabled
          devicesEndpoint
          informationCustomAttributes {
            key
            value
          }
          detailsCustomAttributes {
            key
            value
          }
          wcMessage {
            isWCMessageEnabled
            device {
              tv
              tablet
            }
            messageText
            signature {
              isSignatureEnabled
              signatureTitle
              images
            }
            isImagesEnabled
            images {
              fileName
              index
              master
              ratio16to9
              ratio1to1
              ratio21to9
              ratio9to16
              ratio9to21
            }
            video
          }
          informationCustomAttributes {
            key
            value
          }
          detailsCustomAttributes {
            key
            value
          }
        }
      }
    }
  `;

export const getAccommodationsDetails =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $lang: String) {
      getHotelAccommodationDetails(input: { hotelId: $hotelId, lang: $lang }) {
        categories {
          code
          createdBy
          hotelId
          id
          name
        }
        floors {
          createdAt
          createdBy
          hotelId
          id
          name
          number
          roomRangeList {
            index
            rangeFrom
            rangeTo
          }
        }
        roomTypes {
          categoryId
          category
          code
          createdBy
          description
          displayDescription
          displayName
          features
          hotelId
          id
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to16
            ratio9to21
          }
          mediaContent {
            key
            value
          }
          isActive
          maxAdults
          maxBeddingPerRoomType
          maxChildren
          maxInfants
          maxOccupants
          name
          ratePerNight
        }
        packages {
          name
          id
          hotelId
          description
          code
          isActive
          costPerNight
          createdBy
        }
        rooms {
          area
          areaSizeUnit
          categoryId
          createdBy
          description
          hotelId
          houseKeepingDaySection
          houseKeepingEveningSection
          id
          isActive
          isAdultRequired
          isSmokingAllowed
          maxOccupancy
          number
          roomTypeId
          roomView
        }
        upgrades {
          createdBy
          hotelId
          id
          roomTypeId
          upgradeType {
            upgradeType
            rate
            percent
          }
        }
        personalisations {
          code
          cost
          createdBy
          description
          hotelId
          id
          isActive
          name
          unit
          maxQuantity {
            maxQuantityValue
            status
          }
          personalisationCategory {
            categoryName
            id
          }
        }
        rateFilters {
          code
          createdAt
          createdBy
          customAttributes {
            key
            value
          }
          description
          displayName
          hotelId
          id
          isActive
          lang
          name
          pk
          rateCodeDescription
          rateCodes
          sk
          updatedAt
          updatedBy
          version
        }
        preferences {
          code
          createdAt
          createdBy
          customAttributes {
            key
            value
          }
          description
          hotelId
          id
          isActive
          allowMultipleSelection
          name
          preferenceItems {
            code
            description
            isActive
            name
          }
          updatedAt
          updatedBy
          version
        }
      }
    }
  `;

export const getHotelAmenityDetails =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $lang: String) {
      getHotelAmenityDetails(input: { hotelId: $hotelId, lang: $lang }) {
        section {
          createdBy
          customAttributes {
            key
            value
          }
          hotelId
          id
          name
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to21
            ratio9to16
          }
        }
        categories {
          createdBy
          customAttributes {
            key
            value
          }
          hotelId
          id
          name
          sectionIds
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to21
            ratio9to16
          }
        }
        amenities {
          name
          categoryIds
          createdBy
          customAttributes {
            key
            value
          }
          description
          highlights
          hotelId
          id
          isActive
          information {
            field
            index
            value
            type
            displayTitle
          }
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to16
            ratio9to21
          }
        }
      }
    }
  `;
export const getLocations =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!, $lang: String) {
      getLocations(input: { hotelId: $hotelId, lang: $lang }) {
        id
        name
        createdAt
        createdBy
        description
        hotelId
        type
        updatedAt
        updatedBy
        version
      }
    }
  `;
export const getHotelSystemsModuleSummary = `
  query MyQuery($hotelId: String!) {
    getHotelSystemsModuleConfigurations(input: { hotelId: $hotelId }) {
      isConfirmed
      hotelServiceModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
      entertainmentModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
      guestRoomExpModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
    }
  }
`;
export const GetGuestRoomExpByHotelId = `
query MyQuery($hotelId: String!) {
  GetGuestRoomExpByHotelId(input: {hotelId: $hotelId}) {
    global {
      createdAt
      createdBy
      ddk {
        code
        id
        languageCode
        languageName
        protocol
        provider
      }
      dnd {
        code
        id
        languageCode
        languageName
        protocol
        provider
      }
      hostingPref
      hotelId
      id
      mmr {
        code
        id
        languageCode
        languageName
        protocol
        provider
      }
      pk
      serverConfigType
      sk
      status
      updatedAt
      updatedBy
      version
    }
    rooms {
      areas {
        curtains {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
        ddk {
          name
          vendor {
            attributes {
              value
              key
            }
            id
            name
          }
        }
        id
        lights {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
        name
        thermostats {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
      }
      ddk {
        code
        id
        languageCode
        languageName
        protocol
        provider
      }
      dnd {
        code
        id
        languageCode
        languageName
        protocol
        provider
      }
      hotelId
      mmr {
        code
        id
        languageCode
        languageName
        provider
        protocol
      }
      roomId
      status
      templateId
    }
    templates {
      areas {
        curtains {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
        ddk {
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
          name
        }
        id
        lights {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
        name
        thermostats {
          name
          vendor {
            attributes {
              key
              value
            }
            id
            name
          }
        }
      }
      createdAt
      createdBy
      hotelId
      id
      name
      pk
      sk
      statistics {
        areas
        curtains
        ddk
        lights
        rooms
        thermostats
      }
      updatedAt
      updatedBy
      version
    }
  }
}
`;

export const getGreGlobalConfigs = `
query MyQuery($hotelId: String!) {
  getGreGlobalConfigs(input: {hotelId: $hotelId}) {
    ddkConfigs {
      code
      hotelId
      id
      protocol
      provider
      updatedAt
    }
    defaultConfigs {
      hostingPref
      hotelId
      id
      languages {
        languageCode
        languageName
      }
      serverConfigType
      updatedAt
    }
    dndConfigs {
      code
      hotelId
      id
      protocol
      provider
      updatedAt
    }
    mmrConfigs {
      code
      hotelId
      id
      protocol
      provider
      updatedAt
    }
    doorCameraConfigs {
      hotelId
      ipAddress
      password
      port
      provider
      updatedAt
      username
    }
  }
}
`;

export const getAllRestaurant = `
query MyQuery($hotelId:String!, $lang: String) {
  getRestaurantDetails(input: {hotelId: $hotelId lang: $lang}) {
    chef {
      createdAt
      createdBy
      description
      designation
      email
      hotelId
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio21to9
        ratio1to1
        ratio9to16
        ratio9to21
      }
      mediaContent {
         key
         value
      }
      name
      pk
      phone
      restaurantId
      signatureDish
      sk
      specisalisation
      updatedBy
      updatedAt
      version
    }
    restaurant {
      code
      venueGroupId
      awards
      additionalInformation
      contact {
        URL
        reviewerTitle
        type
        displayTitle
      }
      contactNumber
      email
      createdBy
      cuisine,
      primaryCuisine
      secondaryCuisine
      menuStatus
      ctaTitle
      isActive
      description
      hotelId
      hours {
        close
        day
        open
      }
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      mediaContent {
         key
         value
      }
      location {
        addressLine1
        addressLine2
        area
        city
        country
        postalCode
        state
        latitude
        longitude
        timeZone
      }
      cta{
        ctaTitle
        redirectOption
        redirectUrl
        status
      }
      menu
      menuType
      customAttributes {
        key
        value
      }
      name
      sk
      pk
      type
      updatedBy
      version
      updatedAt
      createdAt
    }
  }
}
`;

export const getRestaurantsByHotel = `
query MyQuery($hotelIds:String!, $lang: String) {
  getRestaurantsByHotelIds(input:{hotelIds: $hotelIds lang: $lang}) {
    additionalInformation
    awards
    code
    contact {
      URL
      displayTitle
      reviewerTitle
      type
    }
    contactNumber
    createdAt
    createdBy
    cta {
      ctaTitle
      redirectOption
      redirectUrl
      status
    }
    ctaTitle
    cuisine
    customAttributes {
      key
      value
    }
    description
    email
    hotelId
    hours {
      close
      day
      open
    }
    id
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    isActive
    location {
      addressLine1
      addressLine2
      area
      city
      country
      latitude
      longitude
      postalCode
      state
      timeZone
    }
    menu
    menuStatus
    menuType
    menuUrl
    name
    pk
    primaryCuisine
    secondaryCuisine
    sk
    type
    updatedAt
    updatedBy
    venueGroupId
    version
  }
}
`;
export const getAllUsers = `
query MyQuery {
  getAllUsers {
    brand
    brandId
    createdAt
    createdBy
    department
    phoneNumber
    lastName
    firstName
    employeeId
    email
    departmentId
    group
    groupId
    hotel
    hotelId
    id
    imageUrl
    pk
    role
    status
    updatedAt
    updatedBy
    version
    roles
    restaurantId
    mfaEnforced
  }
}
`;

export const getDefaultAdminRoles = `
  query MyQuery {
    getAllDefaultRoles {
      name
      id
      permissions {
        accessLevel {
          level
          name
          permission
        }
        category
      }
    }
  }
`;

export const getCustomRolePermissions = `
  query MyQuery($roleIds: [String]!) {
    getCustomRolePermissions(roleIds: $roleIds) {
      permissions {
        accessLevel {
          level
          name
          permission
        }
        category
      }
      name
      isDefault
      id
    }
  }
`;

export const serviceRequestDetails = `
  query MyQuery($hotelId: String!, $lang: String) {
  getServiceRequestDetails(input: {hotelId: $hotelId, lang:$lang }) {
    concierge {
      code
      confirmationMessage
      description
      customSchedule
      hotelId
      icon
      hours {
        allTime
        close
        day
        everyday
        open
      }
      isItemActive
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      mediaContent {
        key
        value
      }
      isActive
      items {
        description
        id
        maxQuantity
        maxQuantityActive
        name
      }
      maxQuantity
      maxQuantityActive
      name
      pk
      resident
      schedule
      sk
      scheduleActive
      createdBy
      updatedAt
      updatedBy
      createdAt
    }
    houseKeeping {
      code
      confirmationMessage
      description
      hotelId
      icon
      customSchedule
      customAttributes {
        key
        value
      }
      hours {
        allTime
        close
        day
        everyday
        open
      }
      isItemActive
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      mediaContent {
        key
        value
      }
      isActive
      items {
        description
        id
        maxQuantity
        maxQuantityActive
        name
      }
      maxQuantity
      maxQuantityActive
      name
      pk
      schedule
      scheduleActive
      sk
      createdBy
      updatedAt
      updatedBy
      createdAt

    }
  }
}`;

export const houseKeepingDetails = `
  query MyQuery ($hotelId: String!, $id: String!, $lang: String){
  getHouseKeeping(input: {hotelId: $hotelId, id: $id, lang: $lang}) {
    code
    confirmationMessage
    description
    hotelId
    customSchedule
    hours {
      allTime
      close
      day
      open
      everyday
    }
    id
    isItemActive
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    isActive
    items {
      description
      id
      maxQuantity
      maxQuantityActive
      name
    }
    maxQuantity
    maxQuantityActive
    name
    pk
    schedule
    scheduleActive
    sk
    createdBy
    updatedAt
    updatedBy
    createdAt
  }
}`;

export const conciergeDetails = `
query MyQuery ($hotelId: String!, $id: String!, $lang: String) {
  getConcierge(input: {hotelId: $hotelId, id: $id, lang: $lang}) {
    code
    confirmationMessage
    description
    hotelId
    customSchedule
    hours {
      allTime
      close
      day
      everyday
      open
    }
    id
    isItemActive
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    isActive
    maxQuantity
    maxQuantityActive
    name
    pk
    resident
    schedule
    scheduleActive
    sk
    createdBy
    updatedAt
    updatedBy
    createdAt
    items {
      description
      id
      maxQuantity
      maxQuantityActive
      name
    }
  }
}`;
export const getInRoomDiningDetails = `
query MyQuery($hotelId:String!, $lang:String, $restaurantId:String) {
  getIRDDetails(input: {hotelId: $hotelId, lang:$lang, restaurantId: $restaurantId,}) {
    addons {
          id
          hotelId
          code
          name
          status
          price
          priceInDecimal
          customAttributes {
            key
            value
          }
      }
      allergens {
          id
          hotelId
          code
          name
          status
          customAttributes {
            key
            value
          }
      }
    bundles {
          id
          hotelId
          code
          name
          status
          price
          description
          items
          customAttributes {
            key
            value
          }
          addons {
              type
              limit
              value
              addons
              groupedAddon{
                title
                addons
                limit
              }
          }
          upsell {
              status
              items
          }
          images {
              index
              fileName
              master
              ratio1to1
              ratio16to9
              ratio21to9
              ratio9to16
              ratio9to21
          }
          mediaContent {
            key
            value
          }
      }
      categories {
          id
          hotelId
          code
          name
          status
          description
          createdAt
          customAttributes {
            key
            value
          }
          hours {
              everyday
              allTime
            timings {
              day
              from
              to
            }
          }
          images {
              index
              fileName
              master
              ratio1to1
              ratio16to9
              ratio9to16
              ratio9to21
              ratio21to9
          }
          mediaContent {
            key
            value
          }
      }
      customisations {
          id
          hotelId
          code
          name
          status
          customAttributes {
            key
            value
          }
      }
      discounts {
          id
          hotelId
          code
          name
          value
          upto
          disclaimer
          description
          status
          customAttributes {
            key
            value
          }
          schedule {
              always
              from {
                  date
                  time
              }
              till {
                  date
                  time
              }
          }
      }
      items {
        id
        hotelId
        code
        name
        status
        type
        price
        description
        ingredients
        allergens
        tags
        customAttributes {
          key
          value
        }
        images {
          fileName
          index
          master
          ratio16to9
          ratio1to1
          ratio9to16
          ratio9to21
          ratio21to9
        }
        mediaContent {
          key
          value
        }
        addons {
          type
          limit
          value
          addons
              groupedAddon{
                title
                addons
                limit
              }
        }
        customisation {
          status
          ingredients {
            ingredient
            customisations
          }
        }
        upsell {
          status
          items
        }
        discount {
          status
          discount
        }
      }
      kinds {
        code
        createdAt
        createdBy
        hotelId
        id
        name
        pk
        sk
        status
        updatedAt
        updatedBy
        version
      }
      tags {
          id
          hotelId
          code
          name
          status
          customAttributes {
            key
            value
          }
      }
  }
}
`;

export const getInRoomDiningMenu = `
query MyQuery($hotelId: String!, $lang: String, $restaurantId:String) {
  getIRDMenuDetails(input: { hotelId: $hotelId , lang: $lang, restaurantId:$restaurantId}) {
    code
    createdAt
    createdBy
    description
    hotelId
    id
    menuURL
    menuType
    categories {
      id
      isActive
      name
      items {
        id
        isActive
        name
        item
      }
      subCategories {
        id
        isActive
        name
        items {
          id
          isActive
          item
          name
        }
      }
      combo {
        id
        isActive
        name
        item
      }
    }
    isActive
    name
    pk
    hours {
      day
      open
      close
    }
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio9to16
      ratio9to21
      ratio21to9
    }
    mediaContent {
      key
      value
    }
    sk
    updatedAt
    updatedBy
    version
  }
}
`;

export const getSpaDetails = `
    query GetSpaDetails($hotelId: String!, $lang:String) {
      getSpaDetails(input: { hotelId: $hotelId , lang: $lang}) {
        categories {
          hotelId
          spaId
          id
          code
          name
          createdBy
          createdAt
          updatedBy
          updatedAt
          version 
          customAttributes {
            key
            value
          }
          images {
            fileName
            index
            master
            ratio16to9
            ratio21to9
            ratio1to1
            ratio9to21
            ratio9to16
          }
          mediaContent {
            key
            value
          }
        }
        spa {
          hotelId
          id
          code
          name
          description
          isActive
          treatmentsMenu
          treatmentsMenuType
          customAttributes {
            key
            value
          }
          hours {
            everyday
            allTime
            timings {
              day
              from
              to
            }
          }
          contact {
            email
            phone
            information {
              type
              reviewerTitle
              url
              displayTitle
            }
          }
          location {
            addressLine1
            addressLine2
            country
            state
            city
            area
            postalCode
            latitude
            longitude
            timeZone
          }
          cta{
            ctaTitle
            redirectOption
            redirectUrl
            status
          }
          images {
            fileName
            index
            master
            ratio16to9
            ratio1to1
            ratio21to9
            ratio9to16
            ratio9to21
          }
          mediaContent {
            key
            value
          }
          createdBy
          createdAt
          updatedBy
          updatedAt
          version
        }
        treatments {
          hotelId
          code
          description
          isActive
          customAttributes {
            key
            value
          }
          disclaimer
          redirectUrl
          duration {
            duration
            price
          }
          id
          images {
            ratio16to9
            ratio21to9
            ratio1to1
            ratio9to16
            ratio9to21
            fileName
            index
            master
          }
          mediaContent {
            key
            value
          }
          name
          spaCategoryId
          spaId
          type
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
    }
  `;

export const getIRDMenuStatus = `
query MyQuery($hotelId:String!,  $lang: String) {
  getIRDMenuStatus(input: {hotelId:$hotelId, lang:$lang}) {
    code
    hotelId
    id
    name
    status
  }
}`;

export const getOffersDetails = `
query MyQuery($hotelId:String!, $lang: String) {
  getOffersDetails(input: {hotelId: $hotelId, lang:$lang
  }) {
    createdAt
    createdBy
    description
    isActive
    name
    hotelId
    id
    highLights
    noOfCards
    customAttributes {
      key
      value
    }
    CTA {
      URL
      cardPlacement
      contact
      emailId
      phoneCode
      phoneNumber
      redirectTo
      type
      status
      displayCTATitle
      redirectData
      moduleId
    }
    duration {
      alwaysActive
      startTime
      startDate
      endTime
      endDate
      everyday
      timings {
        day
        offerTime
      }
    }
    notification {
      createdAt
      description
      devices
      name
    }
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    contact {
      email
      phoneNumber
    }
    selectRestaurant {
      name
      id
    }
    pk
    sk
    type
    updatedAt
    updatedBy
    version
  }
}
`;

export const getOfferCardsDetails = `
query MyQuery($hotelId:String!, $lang: String) {
  getOffersCardDetails(input: {hotelId: $hotelId, lang:$lang
  }) {
    CTA {
      URL
      cardPlacement
      contact
      displayCTATitle
      emailId
      moduleId
      phoneCode
      phoneNumber
      redirectData
      redirectTo
      status
      type
      cardPlacementType
    }
    customAttributes {
      key
      value
    }
    hotelId
    id
    isActive
    offerCardName
    offerCardType
    offerId
    offerRecipient
    offerName
    pk
    postScratchImages {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    preScratchImages {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    popUpImages {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    schedule {
      alwaysActive
      oneTime {
        date
        time
      }
      recurring {
        dates
        endDate
        impression
        recurs
        recursTime
        startDate
        recursWeek
      }
      scheduleType
    }
    sk
  }
}
`;

export const getTelephonyDetails = `
query MyQuery($hotelId: String!, $lang: String) {
  getHotelTelephonyDetails(hotelId: $hotelId, lang:$lang) {
    directories {
      code
      createdAt
      createdBy
      description
      extensionNumber
      extensionPassword
      hotelId
      icon
      id
      isActive
      name
      updatedAt
      updatedBy
      version
    }
    extensions {
      createdAt
      createdBy
      extensionNumber
      id
      hotelId
      roomNumber
      password
      updatedAt
      updatedBy
      version
    }
  }
} 
`;

export const getCampaignOffer = `
query MyQuery ($hotelId: String!, $id: String!){
  getCampaignOffer(input: {hotelId: $hotelId, id: $id}) {
    createdAt
    createdBy
    devices
    hotelId
    id
    isActive
    message
    pk
    offerSchedule {
      impressionsDay
      oneTimeSchedule {
        date
        time
      }
      repeatSchedule {
        days
        everyday
        from
        time
        to
      }
      schedule
    }
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    recipient
    sk
    title
    status
    type
    updatedBy
    updatedAt
    version
  }
} 
`;

export const getCampaignOffersDetails = `
query MyQuery($hotelId: String!, $lang: String) {
      getCampaignOffersDetails(input: {hotelId: $hotelId, 
        lang: $lang
      }) {
    id
    createdAt
    createdBy
    devices
    hotelId
    isActive
    message
    pk
    recipient
    residentFloor
    residentRoomType
    residentRoom
    sk
    status
    title
    type
    updatedAt
    updatedBy
    version
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    offerSchedule {
      impressionsDay
      oneTimeSchedule {
        date
        time
      }
      repeatSchedule {
        days
        everyday
        from
        time
        to
      }
      schedule
    }
  }
} 
`;

export const getBouquetsList = `
query MyQuery($hotelId: String!, $lang:String) {
  listBouquet(input: {hotelId: $hotelId, lang:$lang}) {
    code
    createdAt
    createdBy
    floor
    hotelId
    id
    name
    location
    pk
    room
    sk
    updatedAt
    updatedBy
    version
  }
}
`;

export const getBouquetDetails = `
query MyQuery($hotelId: String!,$id:String!, $lang:String) {
  getBouquet(input: {hotelId: $hotelId,id:$id, lang:$lang}) {
    livetvs {
      categoryId
      categoryName
      bouquet {
        id
        name
      }
      code
      coaxial {
        bandwidth
        digitalTelevisionFormat
        broadCastStandard
        frequency
        majorNumber
        modulationType
        programNumber
        polarization
        satelliteId
        symbolRate
      }
      createdAt
      createdBy
      description
      epgURL
      externalURL
      hotelId
      id
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      iptv {
        port
        url
      }
      isDRM
      language
      isEpgURL
      name
      number
      pk
      sk
      status
      tvType
      updatedAt
      updatedBy
      version
    }
    code
    createdAt
    createdBy
    hotelId
    floor
    id
    location
    name
    room
    updatedAt
    updatedBy
    version
  }
}
`;

export const getCategory = `
query MyQuery($hotelId: String!, $lang:String) {
  listTVCategory(input: {hotelId: $hotelId, lang:$lang}) {
    code
    createdAt
    createdBy
    hotelId
    isActive
    name
    id
    noOfChannel
    sk
    pk
    updatedBy
    version
    updatedAt
  }
}
`;

export const getCategoryChannel = `
query MyQuery($hotelId: String!,$categoryID:String!, $lang:String) {
  listChannelsByCatagoryID(input: {HotelID: $hotelId, categoryID: $categoryID, lang:$lang}) {
    bouquet {
      name
      id
    }
    categoryId
    categoryName
    coaxial {
      bandwidth
      broadCastStandard
      frequency
      digitalTelevisionFormat
      majorNumber
      modulationType
      polarization
      programNumber
      satelliteId
      symbolRate
    }
    code
    createdAt
    createdBy
    description
    epgURL
    hotelId
    id
    externalURL
    isDRM
    isEpgURL
    language
    name
    number
    pk
    sk
    status
    tvType
    updatedAt
    updatedBy
    version
    iptv {
      port
      url
    }
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
  }
}
`;

export const getLiveTV = `
query MyQuery($hotelId: String!,$lang:String) {
  listLiveTv(input: {hotelId: $hotelId, lang: $lang}) {
    bouquet {
      id
      name
    }
    categoryId
    categoryName
    coaxial {
      bandwidth
      broadCastStandard
      digitalTelevisionFormat
      frequency
      modulationType
      majorNumber
      polarization
      programNumber
      satelliteId
      symbolRate
    }
    code
    createdAt
    createdBy
    description
    epgURL
    externalURL
    hotelId
    id
    images {
      fileName
      index
      master
      ratio1to1
      ratio16to9
      ratio21to9
      ratio9to16
      ratio9to21
    }
    mediaContent {
      key
      value
    }
    iptv {
      port
      url
    }
    isDRM
    isEpgURL
    language
    name
    number
    pk
    sk
    status
    updatedAt
    tvType
    updatedBy
    version
  }
}`;

export const getCityGuide = `
query MyQuery($hotelId: String!, $lang: String) {
  getCityGuidesDetails(input:{hotelId: $hotelId, lang: $lang }) {
    categories {
      createdBy
      hotelId
      id
      name
    }
    cityGuides{
      pk
      sk
      id
      categoryName
      categoryId
      hotelId
      name
      code
      description
      distanceFromHotel
      units
      isActive
      duration{
        duration
        validFromDate
        validFromTime
        tillFromDate
        tillFromTime
      }
      location{
        addressLine1
        addressLine2
        country
        state
        city
        area
        postalCode
        latitude
        longitude
        timeZone
      }
      information{
        type
        email
        phone
        URL
        title
        displayTitle
      }
      images{
        fileName
        index
        ratio16to9
        master
        ratio1to1
        ratio21to9
        ratio9to16
        ratio9to21
      }
      mediaContent {
        key
        value
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      version
    }
  }
}
`;

export const cityGuideCategories = `
query MyQuery($hotelId:String!, $lang: String) {
  getCityGuideCategories(input:{hotelId: $hotelId, lang: $lang}) {
    id
    name
  }
}`;

export const listFeedback = `
query MyQuery($hotelId:String!, $lang: String) {
  listFeedback(hotelId: $hotelId, lang: $lang) {
    destination
    duration
    hotelId
    id
    isActive
    pageTitle
    subtext
    feedbackCategories {
      title
      type
    }
  }
}
`;

export const listChannnelCount = `
query MyQuery($hotelId:String!, $lang: String) {
getChannelListMapping(input: {hotelId: $hotelId, lang: $lang}) {
  jsonResponse
}
}
`;

export const getSyncConfigs = `
query MyQuery($hotelId:String!) {
  getSyncConfigs(input: {hotelId: $hotelId}) {
    spa {
      allowedRoles
      hotelId
      isEnabled
      lastSyncedAt
    }
    ird {
      allowedRoles
      hotelId
      isEnabled
      lastSyncedAt
    }
    hk {
      allowedRoles
      hotelId
      isEnabled
      lastSyncedAt
    }
  }
}
`;

export const getTimeZones = `
  query MyQuery {
    getTimeZones {
      offset
      timeZone
    }
  }
`;
export const listWelcomeMessage =
  /* GraphQL */
  `
    query ListWelcomeMessage($hotelId: String!, $lang: String) {
      listWelcomeMessage(input: { hotelId: $hotelId, lang: $lang }) {
        hotelId
        id
        isActive
        title
        deviceTypes
        welcomeMessageTemplate
        audienceType
        confirmationIds
        audienceCriteria {
          blockCodes {
            logic
            values
          }
          floors {
            logic
            values
          }
          loyaltyTiers {
            logic
            values
          }
          roomTypes {
            logic
            values
          }
          rooms {
            values
            logic
          }
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  `;

export const listWelcomeMessageVariables =
  /* GraphQL */
  `
    query ListWelcomeMessageVariables {
      listWelcomeMessageVariables {
        keyword
        type
      }
    }
  `;

export const listEmailTemplateVariables = `
    query ListEmailTemplateVariables($listType: String!) {
      listEmailTemplateVariables(input: { listType: $listType }) {
        keyword
        type
      }
    }
  `;